import React from 'react'
import { IconButton, Paragraph } from '@fs/zion-ui'
import { MenuClose } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

export default function NavigationButtonNo({ onClick, loading, linkName = '' }) {
  const { t } = useTranslation()
  return (
    <div css={navButtonCss()}>
      <IconButton
        data-testid="review-experience-navigation-button-no"
        title={t('full-name-correction.step-one-no', 'No')}
        Icon={MenuClose}
        onClick={onClick}
        color="red"
        emphasis="lightHigh"
        size="lg"
        disabled={loading}
        linkName={linkName}
      />
      <Paragraph size="sm" centered>
        {t('full-name-correction.step-one-no', 'No')}
      </Paragraph>
    </div>
  )
}

export function navButtonCss() {
  return css`
    display: flex;
    flex-flow: column;
    align-items: center;
  `
}
